angular.module 'shared'
  .factory 'SMSesSentThisMonthService', (
    $rootScope,
    $stateParams,
    $http,
  ) ->
    count = 0
    loadingPromise = null
    currentGymId = null

    $rootScope.$on '$stateChangeStart', ->
      loadingPromise = null

    getCount: () -> count
    load: () ->
      gymId = $rootScope.gym?.id || $stateParams.gymId

      if currentGymId != gymId
        loadingPromise = null
        currentGymId = gymId

      return loadingPromise if loadingPromise

      url = "/gyms/#{gymId}/sent_messages/smses_parts_this_month"
      loadingPromise = $http.get(url).then (response) ->
        count = response.data.sms_parts_sent_this_month
      loadingPromise
